import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const changeCatSeqAction = createAsyncThunk(
    'change-category',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/change-cat-seq`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const changeCatSeqSlice = createSlice({
    name: 'change-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(changeCatSeqAction.pending, (state,) => {
                state.loading = true
            })
            builder.addCase(changeCatSeqAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(changeCatSeqAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const changeCatSeqReducer = changeCatSeqSlice.reducer